// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".scroll[data-v-60ffa61e]{display:flex!important;flex-direction:column}.overflow[data-v-60ffa61e]{flex-grow:1;overflow:auto}.dialogTop[data-v-60ffa61e]{bottom:30px;right:25px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
